module.exports = __webpack_public_path__ + "asset/empty_tXj7T5At.png";